import PropTypes from 'prop-types';
import { useState } from 'react';

export const TabContainer = ({ tabs, defaultTab = tabs[0]?.id, rounded = true, variant = 'white' }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);
  const contentBackground = variant === 'white' ? 'bg-white' : 'bg-gray-50';
  const tabsBorder = variant === 'white' ? '' : 'border-b border-gray-200';

  return (
    <div className={`min-h-0 ${rounded ? 'rounded-lg border border-gray-200' : ''}`}>
      <div className={`flex bg-gray-50 ${tabsBorder} ${rounded ? 'rounded-t-lg' : ''}`}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`px-6 py-3 font-medium border-b-2 ${
              activeTab === tab.id
                ? 'text-info border-info bg-white rounded-t-lg'
                : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={`p-4 ${contentBackground} overflow-y-auto h-full ${rounded ? 'rounded-b-lg' : ''}`}>
        {tabs.find(tab => tab.id === activeTab)?.content()}
      </div>
    </div>
  );
};

TabContainer.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      content: PropTypes.func.isRequired,
    }),
  ).isRequired,
  defaultTab: PropTypes.string,
  rounded: PropTypes.bool,
  variant: PropTypes.oneOf(['white', 'gray']),
};
